module.exports = __webpack_public_path__ + "img/carpet.1e32bd78.png";